// extracted by mini-css-extract-plugin
export default {"dot":"DotLoadingIcon__dot____3fbM","dot-flashing":"DotLoadingIcon__dot-flashing___uswcl"};